export const COMPLETED_SUBSCRIPTION_STATUSES = Object.freeze(['active', 'trialing'] as const);

export type CheckoutResponseClassification =
  | {
      kind: 'completed_subscription';
      response: Record<string, unknown>;
      subscriptionId: string;
      customerId: string | null;
      status: 'active' | 'trialing';
    }
  | {
      kind: 'requires_confirmation';
      response: Record<string, unknown>;
      clientSecret: string;
    }
  | {
      kind: 'invalid';
      response: Record<string, unknown>;
      reason: 'invalid_completed_subscription' | 'missing_client_secret';
    };

const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value && typeof value === 'object' && !Array.isArray(value));

export function classifyCheckoutResponse(value: unknown): CheckoutResponseClassification {
  const response = isRecord(value) ? value : {};
  if (response.checkoutComplete === true) {
    const status = typeof response.status === 'string' ? response.status.toLowerCase() : '';
    const subscriptionId = typeof response.subscriptionId === 'string'
      ? response.subscriptionId.trim()
      : '';
    if (
      response.nextStep === 'subscription_active'
      && subscriptionId
      && COMPLETED_SUBSCRIPTION_STATUSES.includes(status as 'active' | 'trialing')
    ) {
      return {
        kind: 'completed_subscription',
        response,
        subscriptionId,
        customerId: typeof response.customerId === 'string' ? response.customerId : null,
        status: status as 'active' | 'trialing',
      };
    }
    return { kind: 'invalid', response, reason: 'invalid_completed_subscription' };
  }

  const clientSecret = typeof response.clientSecret === 'string'
    ? response.clientSecret.trim()
    : '';
  if (clientSecret) {
    return { kind: 'requires_confirmation', response, clientSecret };
  }

  return { kind: 'invalid', response, reason: 'missing_client_secret' };
}

export const isCompletedSubscriptionCheckout = (value: unknown): boolean =>
  classifyCheckoutResponse(value).kind === 'completed_subscription';
